import { IBusinessType } from '@/models/business';

// The in-store redemption flow is built for physical-only businesses, so a
// physical + online one may set up an online loyalty program only. In-Store is
// shown but blocked, so the merchant learns it exists; the combined option is
// hidden outright.
export function isLoyaltyOperationHidden(
  businessType: string,
  operation: string
) {
  return (
    businessType === IBusinessType.BOTH && operation === IBusinessType.BOTH
  );
}

export function isLoyaltyOperationBlocked(
  businessType: string,
  operation: string
) {
  return (
    businessType === IBusinessType.BOTH && operation === IBusinessType.INSTORE
  );
}

// With Online as the only option left, the setup modal picks it for a
// physical + online business instead of showing the operation step.
export function impliedLoyaltyOperation(businessType: string) {
  return businessType === IBusinessType.BOTH ? IBusinessType.ONLINE : undefined;
}
